
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea9ac"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea9ac"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4b14ad7ed75be8c$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $csZ3p = parcelRequire("csZ3p");

var $gu6an = parcelRequire("gu6an");

var $7kSGc = parcelRequire("7kSGc");

var $eEby5 = parcelRequire("eEby5");
var $e4b14ad7ed75be8c$var$AppState;
(function(AppState) {
    AppState[AppState["Splash"] = 0] = "Splash";
    AppState[AppState["Intro"] = 1] = "Intro";
    AppState[AppState["Experience"] = 2] = "Experience";
})($e4b14ad7ed75be8c$var$AppState || ($e4b14ad7ed75be8c$var$AppState = {}));
var $e4b14ad7ed75be8c$var$RecordingState;
(function(RecordingState) {
    RecordingState[RecordingState["Ready"] = 0] = "Ready";
    RecordingState[RecordingState["Recording"] = 1] = "Recording";
    RecordingState[RecordingState["Stopped"] = 2] = "Stopped";
})($e4b14ad7ed75be8c$var$RecordingState || ($e4b14ad7ed75be8c$var$RecordingState = {}));
var // Event handling.
$e4b14ad7ed75be8c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    __name: "App",
    setup (__props, { expose: __expose }) {
        __expose();
        const inputManager = new (0, $gu6an.default)();
        const audioManager = new (0, $7kSGc.default)();
        const audioRecorder = new (0, $eEby5.default)();
        const seconds = (0, $01W3b.ref)(0);
        const masterIntensity = (0, $01W3b.ref)(1);
        const channel = (0, $01W3b.ref)(0);
        const masterVolume = (0, $01W3b.ref)(1);
        const trackVolumes = (0, $01W3b.ref)([
            0,
            0,
            1
        ]);
        inputManager.addEventListener("clockwise", ()=>{
            if (appState.value == 2) audioManager.intensityUp();
        });
        inputManager.addEventListener("counterclockwise", ()=>{
            if (appState.value == 2) audioManager.intensityDown();
        });
        inputManager.addEventListener("press", ()=>{
            channelNext();
        });
        inputManager.addEventListener("pressclockwise", ()=>{
            volumeUp();
        });
        inputManager.addEventListener("presscounterclockwise", ()=>{
            volumeDown();
        });
        inputManager.addEventListener("longpress", ()=>{
            if (appState.value == 0) start();
            else if (appState.value == 1) next();
        });
        audioManager.addEventListener("intensityChange", (event)=>{
            masterIntensity.value = event.detail.intensity;
            trackVolumes.value = event.detail.volumes;
        });
        (0, $TusQn.onMounted)(()=>{
            // Use a callback to continuously update the seconds property
            const updateSeconds = ()=>{
                seconds.value = audioManager.time;
                requestAnimationFrame(updateSeconds);
            };
            updateSeconds();
            audioRecorder.requestMicrophonePermission();
        });
        // Filename metadata.
        let sessionId = Math.floor(Math.random() * 9999).toString().padStart(4, "0");
        let startTime = Date.now();
        const appState = (0, $01W3b.ref)(0);
        const recordingState = (0, $01W3b.ref)(0);
        const recordingIndex = (0, $01W3b.ref)(0);
        const floatToPercent = (value)=>{
            return (value * 100).toFixed(0).toString() + "%";
        };
        const start = ()=>{
            appState.value = 1;
            audioManager.initialize();
            audioManager.playBackground();
        };
        const seek = (time)=>{
            audioManager.seek(time);
        };
        const next = ()=>{
            appState.value = 2;
            audioManager.stopBackground();
            audioManager.start();
        };
        // Volume
        const volumeDown = ()=>{
            masterVolume.value = audioManager.volumeDown();
        };
        const volumeUp = ()=>{
            masterVolume.value = audioManager.volumeUp();
        };
        const volumeSet = (value)=>{
            masterVolume.value = audioManager.volumeSet(value);
        };
        //
        const pauseAllTracks = ()=>{
            audioManager.pauseAllTracks();
        };
        const resumeAllTracks = ()=>{
            audioManager.resumeAllTracks();
        };
        // Channel
        const channelPrevious = ()=>{
            channel.value = audioManager.channelPrevious();
        };
        const channelNext = ()=>{
            channel.value = audioManager.channelNext();
        };
        const channelSet = (index)=>{
            console.log("Channel set: " + index);
            channel.value = audioManager.channelSet(index);
        };
        // Intensity
        const intensityUp = ()=>{
            audioManager.intensityUp();
        };
        const intensityDown = ()=>{
            audioManager.intensityDown();
        };
        const intensityMax = ()=>{
            audioManager.intensitySet(1);
        };
        const intensityMin = ()=>{
            audioManager.intensitySet(0);
        };
        const intensityHalf = ()=>{
            audioManager.intensitySet(.5);
        };
        const intensitySet = (value)=>{
            audioManager.intensitySet(value);
        };
        // Recording
        const startRecording = ()=>{
            console.log("Starting recording.");
            recordingState.value = 1;
            recordingIndex.value++;
            // audioManager.startRecording();
            audioRecorder.startRecording();
        };
        const stopRecording = async ()=>{
            console.log("Stopping recording.");
            recordingState.value = 2;
            // await audioManager.stopRecording();
            audioRecorder.stopRecording();
        };
        const saveRecording = ()=>{
            const elapsedTime = Math.floor((Date.now() - startTime) / 1000).toString().padStart(3, "0");
            const recordingId = recordingIndex.value.toString().padStart(2, "0");
            const intensity = Math.floor(audioManager.intensity * 100).toString().padStart(3, "0");
            const date = new Date();
            const dateStamp = date.getFullYear().toString() + (date.getMonth() + 1).toString().padStart(2, "0") + date.getDate().toString().padStart(2, "0");
            const filename = `id_${sessionId}_date_${dateStamp}_take_${recordingId}_time_${elapsedTime}_intensity_${intensity}`;
            console.log(filename);
            // audioManager.saveRecording(filename);
            audioRecorder.saveRecording(filename);
            recordingState.value = 0;
        };
        const __returned__ = {
            inputManager: inputManager,
            audioManager: audioManager,
            audioRecorder: audioRecorder,
            seconds: seconds,
            masterIntensity: masterIntensity,
            channel: channel,
            masterVolume: masterVolume,
            trackVolumes: trackVolumes,
            AppState: $e4b14ad7ed75be8c$var$AppState,
            RecordingState: $e4b14ad7ed75be8c$var$RecordingState,
            get sessionId () {
                return sessionId;
            },
            set sessionId (v){
                sessionId = v;
            },
            get startTime () {
                return startTime;
            },
            set startTime (v){
                startTime = v;
            },
            appState: appState,
            recordingState: recordingState,
            recordingIndex: recordingIndex,
            floatToPercent: floatToPercent,
            start: start,
            seek: seek,
            next: next,
            volumeDown: volumeDown,
            volumeUp: volumeUp,
            volumeSet: volumeSet,
            pauseAllTracks: pauseAllTracks,
            resumeAllTracks: resumeAllTracks,
            channelPrevious: channelPrevious,
            channelNext: channelNext,
            channelSet: channelSet,
            intensityUp: intensityUp,
            intensityDown: intensityDown,
            intensityMax: intensityMax,
            intensityMin: intensityMin,
            intensityHalf: intensityHalf,
            intensitySet: intensitySet,
            startRecording: startRecording,
            stopRecording: stopRecording,
            saveRecording: saveRecording,
            get Icon () {
                return 0, $csZ3p.Icon;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("eeJ70")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
parcelRequire("eeJ70");
var $TusQn = parcelRequire("TusQn");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("TusQn")).watchPostEffect);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);

var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (isSVG) {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = "Transition";
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOldKey = Symbol("_vod");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOldKey] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOldKey] : "none";
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $8POXm.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
        }
        for(const key in next)$a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ($a5d55dc64ccb07cf$var$vShowOldKey in el) style.display = currentDisplay;
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        const oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$nativeOnRE = /^on[a-z]/;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$nativeOnRE.test(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($a5d55dc64ccb07cf$var$nativeOnRE.test(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $8POXm.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.watchPostEffect)(setVars);
    (0, $TusQn.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $a5d55dc64ccb07cf$var$removeMode($a5d55dc64ccb07cf$var$TransitionGroupImpl.props);
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8POXm.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $8POXm.looseToNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $8POXm.isArray)(value)) el.checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $8POXm.isArray)(value) && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if ((0, $8POXm.isArray)(value)) option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);

var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$export$c106dd0671a0fc2d(msg, ...args) {
    var vnode;
    return;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value1, raw) {
    if ((0, $8POXm.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            `${key}=${value1}`
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        `${key}=${value1}`
    ];
    else if ((0, $01W3b.isRef)(value1)) {
        value1 = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value1.value), true);
        return raw ? value1 : [
            `${key}=Ref<`,
            value1,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value1)) return [
        `${key}=fn${value1.name ? `<${value1.name}>` : ``}`
    ];
    else {
        value1 = (0, $01W3b.toRaw)(value1);
        return raw ? value1 : [
            `${key}=`,
            value1
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$var$ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(seen, i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ];
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        $0a6cc4ba868319ae$var$activePostFlushCbs.sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++)$0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$export$6922d3b3a607469e;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e) $0a6cc4ba868319ae$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$export$6922d3b3a607469e = hook;
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e) {
        $0a6cc4ba868319ae$export$6922d3b3a607469e.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$export$6922d3b3a607469e.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$export$6922d3b3a607469e && typeof $0a6cc4ba868319ae$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$export$6922d3b3a607469e.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8POXm.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor2, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                let { anchor: anchor2 } = suspense;
                if (activeBranch) {
                    anchor2 = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, isSVG: isSVG2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                isSVG2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $8POXm.EMPTY_OBJ)) {
    var _a;
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = (0, $01W3b.getCurrentScope)() === ((_a = $0a6cc4ba868319ae$var$currentInstance) == null ? void 0 : _a.scope) ? $0a6cc4ba868319ae$var$currentInstance : null;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return $0a6cc4ba868319ae$var$traverse(s);
                else if ((0, $8POXm.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        onCleanup = (0, $8POXm.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $8POXm.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE) : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8POXm.hasChanged)(v1, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    const unwatch = ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $8POXm.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value1, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    const cur = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $0a6cc4ba868319ae$var$setCurrentInstance(cur);
    else $0a6cc4ba868319ae$var$unsetCurrentInstance();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value1, seen) {
    if (!(0, $8POXm.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $01W3b.isRef)(value1)) $0a6cc4ba868319ae$var$traverse(value1.value, seen);
    else if ((0, $8POXm.isArray)(value1)) for(let i = 0; i < value1.length; i++)$0a6cc4ba868319ae$var$traverse(value1[i], seen);
    else if ((0, $8POXm.isSet)(value1) || (0, $8POXm.isMap)(value1)) value1.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value1)) for(const key in value1)$0a6cc4ba868319ae$var$traverse(value1[key], seen);
    return value1;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value1, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $0a6cc4ba868319ae$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && (!$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    return $0a6cc4ba868319ae$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            $0a6cc4ba868319ae$var$unsetCurrentInstance();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") && $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8POXm.isArray)(source) || (0, $8POXm.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$0a6cc4ba868319ae$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value1) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value1;
            return true;
        } else {
            if (data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value1;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value1;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8POXm.hasOwn)(normalizedProps, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (options && options.local) {
        const proxy = (0, $01W3b.ref)(props[name]);
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>props[name], (v1)=>proxy.value = v1);
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(proxy, (value1)=>{
            if (value1 !== props[name]) i.emit(`update:${name}`, value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit(`update:${name}`, value);
        }
    };
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext (fn) {
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value1) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $0a6cc4ba868319ae$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $8POXm.def)(attrs, $0a6cc4ba868319ae$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value1 = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance, "set", "$attrs");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value1 = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $0a6cc4ba868319ae$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $8POXm.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            if (prop) {
                const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8POXm.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8POXm.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, !(0, $8POXm.hasOwn)(rawProps, key) && !(0, $8POXm.hasOwn)(rawProps, (0, $8POXm.hyphenate)(key)));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value1, prop, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value1, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$export$c106dd0671a0fc2d($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value1, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value1;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value1);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value1, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value1, type) {
    if (type === "String") return `"${value1}"`;
    else if (type === "Number") return `${Number(value1)}`;
    else return `${value1}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value1)=>(0, $8POXm.isArray)(value1) ? value1.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value1)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value1 = rawSlots[key];
        if ((0, $8POXm.isFunction)(value1)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value1);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $01W3b.toRaw)(children);
            (0, $8POXm.def)(children, "_", type);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
    }
    (0, $8POXm.def)(instance.slots, $0a6cc4ba868319ae$var$InternalObjectKey, 1);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $8POXm.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value1 = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8POXm.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8POXm.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $8POXm.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) {
                    if (node.tagName.toLowerCase() === "template") {
                        const content = vnode.el.content.firstChild;
                        replaceNode(content, node, parentComponent);
                        vnode.el = node = content;
                        nextNode = nextSibling(node);
                    } else nextNode = onMismatch();
                } else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) {
                parent.vnode.el = newNode;
                parent.subTree.el = newNode;
            }
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, isSVG)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs();
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $0a6cc4ba868319ae$var$flushPreFlushCbs();
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $0a6cc4ba868319ae$var$isTargetSVG(target);
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $0a6cc4ba868319ae$var$isTargetSVG(target);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value1) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value1;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$InternalObjectKey = `__vInternal`;
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$InternalObjectKey in props ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($0a6cc4ba868319ae$var$InternalObjectKey in children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$globalCurrentInstanceSetters;
let $0a6cc4ba868319ae$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($0a6cc4ba868319ae$var$globalCurrentInstanceSetters = (0, $8POXm.getGlobalThis)()[$0a6cc4ba868319ae$var$settersKey])) $0a6cc4ba868319ae$var$globalCurrentInstanceSetters = (0, $8POXm.getGlobalThis)()[$0a6cc4ba868319ae$var$settersKey] = [];
$0a6cc4ba868319ae$var$globalCurrentInstanceSetters.push((i)=>$0a6cc4ba868319ae$var$currentInstance = i);
$0a6cc4ba868319ae$var$internalSetCurrentInstance = (instance)=>{
    if ($0a6cc4ba868319ae$var$globalCurrentInstanceSetters.length > 1) $0a6cc4ba868319ae$var$globalCurrentInstanceSetters.forEach((s)=>s(instance));
    else $0a6cc4ba868319ae$var$globalCurrentInstanceSetters[0](instance);
};
const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $8POXm.NO);
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || appIsNativeTag(name)) $0a6cc4ba868319ae$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    $0a6cc4ba868319ae$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $01W3b.markRaw)(new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        $0a6cc4ba868319ae$var$unsetCurrentInstance();
        if ((0, $8POXm.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            $0a6cc4ba868319ae$var$unsetCurrentInstance();
        }
    }
}
function $0a6cc4ba868319ae$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $0a6cc4ba868319ae$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value1) {
    return (0, $8POXm.isFunction)(value1) && "__vccOpts" in value1;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($0a6cc4ba868319ae$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.3.7";
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);

var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
const $005d1fb7704e278c$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $005d1fb7704e278c$var$wasTracked = (dep)=>(dep.w & $005d1fb7704e278c$var$trackOpBit) > 0;
const $005d1fb7704e278c$var$newTracked = (dep)=>(dep.n & $005d1fb7704e278c$var$trackOpBit) > 0;
const $005d1fb7704e278c$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $005d1fb7704e278c$var$trackOpBit;
};
const $005d1fb7704e278c$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($005d1fb7704e278c$var$wasTracked(dep) && !$005d1fb7704e278c$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$005d1fb7704e278c$var$trackOpBit;
            dep.n &= ~$005d1fb7704e278c$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$effectTrackDepth = 0;
let $005d1fb7704e278c$var$trackOpBit = 1;
const $005d1fb7704e278c$var$maxMarkerBits = 30;
let $005d1fb7704e278c$var$activeEffect;
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $005d1fb7704e278c$var$activeEffect;
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $005d1fb7704e278c$var$activeEffect;
            $005d1fb7704e278c$var$activeEffect = this;
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$trackOpBit = 1 << ++$005d1fb7704e278c$var$effectTrackDepth;
            if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) $005d1fb7704e278c$var$initDepMarkers(this);
            else $005d1fb7704e278c$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) $005d1fb7704e278c$var$finalizeDepMarkers(this);
            $005d1fb7704e278c$var$trackOpBit = 1 << --$005d1fb7704e278c$var$effectTrackDepth;
            $005d1fb7704e278c$var$activeEffect = this.parent;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
            this.parent = void 0;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        if ($005d1fb7704e278c$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $005d1fb7704e278c$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$cleanupEffect(effect2) {
    const { deps: deps } = effect2;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) {
        (0, $8POXm.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep());
        const eventInfo = void 0;
        $005d1fb7704e278c$var$trackEffects(dep, eventInfo);
    }
}
function $005d1fb7704e278c$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack2 = false;
    if ($005d1fb7704e278c$var$effectTrackDepth <= $005d1fb7704e278c$var$maxMarkerBits) {
        if (!$005d1fb7704e278c$var$newTracked(dep)) {
            dep.n |= $005d1fb7704e278c$var$trackOpBit;
            shouldTrack2 = !$005d1fb7704e278c$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($005d1fb7704e278c$var$activeEffect);
    if (shouldTrack2) {
        dep.add($005d1fb7704e278c$var$activeEffect);
        $005d1fb7704e278c$var$activeEffect.deps.push(dep);
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $8POXm.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $8POXm.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $8POXm.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $8POXm.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $005d1fb7704e278c$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $005d1fb7704e278c$var$triggerEffects($005d1fb7704e278c$var$createDep(effects));
    }
}
function $005d1fb7704e278c$var$triggerEffects(dep, debuggerEventExtraInfo) {
    const effects = (0, $8POXm.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect2 of effects)if (effect2.computed) $005d1fb7704e278c$var$triggerEffect(effect2, debuggerEventExtraInfo);
    for (const effect2 of effects)if (!effect2.computed) $005d1fb7704e278c$var$triggerEffect(effect2, debuggerEventExtraInfo);
}
function $005d1fb7704e278c$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $005d1fb7704e278c$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $005d1fb7704e278c$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
const $005d1fb7704e278c$var$arrayInstrumentations = /* @__PURE__ */ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _shallow = false){
        this._isReadonly = _isReadonly;
        this._shallow = _shallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, shallow = this._shallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : shallow ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $8POXm.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(shallow = false){
        super(false, shallow);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if ($005d1fb7704e278c$export$92d09b48637741e7(oldValue) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) return false;
        if (!this._shallow) {
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8POXm.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key) ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(shallow = false){
        super(true, shallow);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $005d1fb7704e278c$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return $005d1fb7704e278c$export$352205f445242f02(value) || $005d1fb7704e278c$export$92d09b48637741e7(value);
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
function $005d1fb7704e278c$var$trackRefValue(ref2) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
        $005d1fb7704e278c$var$trackEffects(ref2.dep || (ref2.dep = $005d1fb7704e278c$var$createDep()));
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref2, newVal) {
    ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $005d1fb7704e278c$var$triggerEffects(dep);
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $8POXm.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    $005d1fb7704e278c$var$triggerRefValue(ref2, void 0);
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $005d1fb7704e278c$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $8POXm.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $8POXm.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$var$tick = /* @__PURE__ */ Promise.resolve();
const $005d1fb7704e278c$var$queue = [];
let $005d1fb7704e278c$var$queued = false;
const $005d1fb7704e278c$var$scheduler = (fn)=>{
    $005d1fb7704e278c$var$queue.push(fn);
    if (!$005d1fb7704e278c$var$queued) {
        $005d1fb7704e278c$var$queued = true;
        $005d1fb7704e278c$var$tick.then($005d1fb7704e278c$var$flush);
    }
};
const $005d1fb7704e278c$var$flush = ()=>{
    for(let i = 0; i < $005d1fb7704e278c$var$queue.length; i++)$005d1fb7704e278c$var$queue[i]();
    $005d1fb7704e278c$var$queue.length = 0;
    $005d1fb7704e278c$var$queued = false;
};
class $005d1fb7704e278c$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $005d1fb7704e278c$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $005d1fb7704e278c$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                for (const e of this.dep)if (e.computed instanceof $005d1fb7704e278c$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return $005d1fb7704e278c$export$ab18938b9fc5f28e(this)._get();
    }
}
function $005d1fb7704e278c$export$483264c4ec4c46ce(getter) {
    return new $005d1fb7704e278c$var$DeferredComputedRefImpl(getter);
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$var$onRE = /^on[^a-z]/;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>$66ea9d0aaa418c4d$var$onRE.test(key);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-(\w)/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});





parcelRegister("csZ3p", function(module, exports) {

$parcel$export(module.exports, "Icon", () => Icon);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
const stringToIcon = (value, validate, allowSimpleName, provider = "")=>{
    const colonSeparated = value.split(":");
    if (value.slice(0, 1) === "@") {
        if (colonSeparated.length < 2 || colonSeparated.length > 3) return null;
        provider = colonSeparated.shift().slice(1);
    }
    if (colonSeparated.length > 3 || !colonSeparated.length) return null;
    if (colonSeparated.length > 1) {
        const name2 = colonSeparated.pop();
        const prefix = colonSeparated.pop();
        const result = {
            // Allow provider without '@': "provider:prefix:name"
            provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
            prefix: prefix,
            name: name2
        };
        return validate && !validateIconName(result) ? null : result;
    }
    const name = colonSeparated[0];
    const dashSeparated = name.split("-");
    if (dashSeparated.length > 1) {
        const result = {
            provider: provider,
            prefix: dashSeparated.shift(),
            name: dashSeparated.join("-")
        };
        return validate && !validateIconName(result) ? null : result;
    }
    if (allowSimpleName && provider === "") {
        const result = {
            provider: provider,
            prefix: "",
            name: name
        };
        return validate && !validateIconName(result, allowSimpleName) ? null : result;
    }
    return null;
};
const validateIconName = (icon, allowSimpleName)=>{
    if (!icon) return false;
    return !!((icon.provider === "" || icon.provider.match(matchIconName)) && (allowSimpleName && icon.prefix === "" || icon.prefix.match(matchIconName)) && icon.name.match(matchIconName));
};
const defaultIconDimensions = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
});
const defaultIconTransformations = Object.freeze({
    rotate: 0,
    vFlip: false,
    hFlip: false
});
const defaultIconProps = Object.freeze({
    ...defaultIconDimensions,
    ...defaultIconTransformations
});
const defaultExtendedIconProps = Object.freeze({
    ...defaultIconProps,
    body: "",
    hidden: false
});
function mergeIconTransformations(obj1, obj2) {
    const result = {};
    if (!obj1.hFlip !== !obj2.hFlip) result.hFlip = true;
    if (!obj1.vFlip !== !obj2.vFlip) result.vFlip = true;
    const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
    if (rotate) result.rotate = rotate;
    return result;
}
function mergeIconData(parent, child) {
    const result = mergeIconTransformations(parent, child);
    for(const key in defaultExtendedIconProps){
        if (key in defaultIconTransformations) {
            if (key in parent && !(key in result)) result[key] = defaultIconTransformations[key];
        } else if (key in child) result[key] = child[key];
        else if (key in parent) result[key] = parent[key];
    }
    return result;
}
function getIconsTree(data, names) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    const resolved = /* @__PURE__ */ Object.create(null);
    function resolve(name) {
        if (icons[name]) return resolved[name] = [];
        if (!(name in resolved)) {
            resolved[name] = null;
            const parent = aliases[name] && aliases[name].parent;
            const value = parent && resolve(parent);
            if (value) resolved[name] = [
                parent
            ].concat(value);
        }
        return resolved[name];
    }
    (names || Object.keys(icons).concat(Object.keys(aliases))).forEach(resolve);
    return resolved;
}
function internalGetIconData(data, name, tree) {
    const icons = data.icons;
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    let currentProps = {};
    function parse(name2) {
        currentProps = mergeIconData(icons[name2] || aliases[name2], currentProps);
    }
    parse(name);
    tree.forEach(parse);
    return mergeIconData(data, currentProps);
}
function parseIconSet(data, callback) {
    const names = [];
    if (typeof data !== "object" || typeof data.icons !== "object") return names;
    if (data.not_found instanceof Array) data.not_found.forEach((name)=>{
        callback(name, null);
        names.push(name);
    });
    const tree = getIconsTree(data);
    for(const name in tree){
        const item = tree[name];
        if (item) {
            callback(name, internalGetIconData(data, name, item));
            names.push(name);
        }
    }
    return names;
}
const optionalPropertyDefaults = {
    provider: "",
    aliases: {},
    not_found: {},
    ...defaultIconDimensions
};
function checkOptionalProps(item, defaults) {
    for(const prop in defaults){
        if (prop in item && typeof item[prop] !== typeof defaults[prop]) return false;
    }
    return true;
}
function quicklyValidateIconSet(obj) {
    if (typeof obj !== "object" || obj === null) return null;
    const data = obj;
    if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") return null;
    if (!checkOptionalProps(obj, optionalPropertyDefaults)) return null;
    const icons = data.icons;
    for(const name in icons){
        const icon = icons[name];
        if (!name.match(matchIconName) || typeof icon.body !== "string" || !checkOptionalProps(icon, defaultExtendedIconProps)) return null;
    }
    const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
    for(const name in aliases){
        const icon = aliases[name];
        const parent = icon.parent;
        if (!name.match(matchIconName) || typeof parent !== "string" || !icons[parent] && !aliases[parent] || !checkOptionalProps(icon, defaultExtendedIconProps)) return null;
    }
    return data;
}
const dataStorage = /* @__PURE__ */ Object.create(null);
function newStorage(provider, prefix) {
    return {
        provider: provider,
        prefix: prefix,
        icons: /* @__PURE__ */ Object.create(null),
        missing: /* @__PURE__ */ new Set()
    };
}
function getStorage(provider, prefix) {
    const providerStorage = dataStorage[provider] || (dataStorage[provider] = /* @__PURE__ */ Object.create(null));
    return providerStorage[prefix] || (providerStorage[prefix] = newStorage(provider, prefix));
}
function addIconSet(storage, data) {
    if (!quicklyValidateIconSet(data)) return [];
    return parseIconSet(data, (name, icon)=>{
        if (icon) storage.icons[name] = icon;
        else storage.missing.add(name);
    });
}
function addIconToStorage(storage, name, icon) {
    try {
        if (typeof icon.body === "string") {
            storage.icons[name] = {
                ...icon
            };
            return true;
        }
    } catch (err) {}
    return false;
}
function listIcons(provider, prefix) {
    let allIcons = [];
    const providers = typeof provider === "string" ? [
        provider
    ] : Object.keys(dataStorage);
    providers.forEach((provider2)=>{
        const prefixes = typeof provider2 === "string" && typeof prefix === "string" ? [
            prefix
        ] : Object.keys(dataStorage[provider2] || {});
        prefixes.forEach((prefix2)=>{
            const storage = getStorage(provider2, prefix2);
            allIcons = allIcons.concat(Object.keys(storage.icons).map((name)=>(provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name));
        });
    });
    return allIcons;
}
let simpleNames = false;
function allowSimpleNames(allow) {
    if (typeof allow === "boolean") simpleNames = allow;
    return simpleNames;
}
function getIconData(name) {
    const icon = typeof name === "string" ? stringToIcon(name, true, simpleNames) : name;
    if (icon) {
        const storage = getStorage(icon.provider, icon.prefix);
        const iconName = icon.name;
        return storage.icons[iconName] || (storage.missing.has(iconName) ? null : void 0);
    }
}
function addIcon(name, data) {
    const icon = stringToIcon(name, true, simpleNames);
    if (!icon) return false;
    const storage = getStorage(icon.provider, icon.prefix);
    return addIconToStorage(storage, icon.name, data);
}
function addCollection(data, provider) {
    if (typeof data !== "object") return false;
    if (typeof provider !== "string") provider = data.provider || "";
    if (simpleNames && !provider && !data.prefix) {
        let added = false;
        if (quicklyValidateIconSet(data)) {
            data.prefix = "";
            parseIconSet(data, (name, icon)=>{
                if (icon && addIcon(name, icon)) added = true;
            });
        }
        return added;
    }
    const prefix = data.prefix;
    if (!validateIconName({
        provider: provider,
        prefix: prefix,
        name: "a"
    })) return false;
    const storage = getStorage(provider, prefix);
    return !!addIconSet(storage, data);
}
function iconExists(name) {
    return !!getIconData(name);
}
function getIcon(name) {
    const result = getIconData(name);
    return result ? {
        ...defaultIconProps,
        ...result
    } : null;
}
const defaultIconSizeCustomisations = Object.freeze({
    width: null,
    height: null
});
const defaultIconCustomisations = Object.freeze({
    // Dimensions
    ...defaultIconSizeCustomisations,
    // Transformations
    ...defaultIconTransformations
});
const unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
const unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function calculateSize(size, ratio, precision) {
    if (ratio === 1) return size;
    precision = precision || 100;
    if (typeof size === "number") return Math.ceil(size * ratio * precision) / precision;
    if (typeof size !== "string") return size;
    const oldParts = size.split(unitsSplit);
    if (oldParts === null || !oldParts.length) return size;
    const newParts = [];
    let code = oldParts.shift();
    let isNumber = unitsTest.test(code);
    while(true){
        if (isNumber) {
            const num = parseFloat(code);
            if (isNaN(num)) newParts.push(code);
            else newParts.push(Math.ceil(num * ratio * precision) / precision);
        } else newParts.push(code);
        code = oldParts.shift();
        if (code === void 0) return newParts.join("");
        isNumber = !isNumber;
    }
}
const isUnsetKeyword = (value)=>value === "unset" || value === "undefined" || value === "none";
function iconToSVG(icon, customisations) {
    const fullIcon = {
        ...defaultIconProps,
        ...icon
    };
    const fullCustomisations = {
        ...defaultIconCustomisations,
        ...customisations
    };
    const box = {
        left: fullIcon.left,
        top: fullIcon.top,
        width: fullIcon.width,
        height: fullIcon.height
    };
    let body = fullIcon.body;
    [
        fullIcon,
        fullCustomisations
    ].forEach((props)=>{
        const transformations = [];
        const hFlip = props.hFlip;
        const vFlip = props.vFlip;
        let rotation = props.rotate;
        if (hFlip) {
            if (vFlip) rotation += 2;
            else {
                transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
                transformations.push("scale(-1 1)");
                box.top = box.left = 0;
            }
        } else if (vFlip) {
            transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
            transformations.push("scale(1 -1)");
            box.top = box.left = 0;
        }
        let tempValue;
        if (rotation < 0) rotation -= Math.floor(rotation / 4) * 4;
        rotation = rotation % 4;
        switch(rotation){
            case 1:
                tempValue = box.height / 2 + box.top;
                transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
            case 2:
                transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
                break;
            case 3:
                tempValue = box.width / 2 + box.left;
                transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
                break;
        }
        if (rotation % 2 === 1) {
            if (box.left !== box.top) {
                tempValue = box.left;
                box.left = box.top;
                box.top = tempValue;
            }
            if (box.width !== box.height) {
                tempValue = box.width;
                box.width = box.height;
                box.height = tempValue;
            }
        }
        if (transformations.length) body = '<g transform="' + transformations.join(" ") + '">' + body + "</g>";
    });
    const customisationsWidth = fullCustomisations.width;
    const customisationsHeight = fullCustomisations.height;
    const boxWidth = box.width;
    const boxHeight = box.height;
    let width;
    let height;
    if (customisationsWidth === null) {
        height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
        width = calculateSize(height, boxWidth / boxHeight);
    } else {
        width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
        height = customisationsHeight === null ? calculateSize(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    }
    const attributes = {};
    const setAttr = (prop, value)=>{
        if (!isUnsetKeyword(value)) attributes[prop] = value.toString();
    };
    setAttr("width", width);
    setAttr("height", height);
    attributes.viewBox = box.left.toString() + " " + box.top.toString() + " " + boxWidth.toString() + " " + boxHeight.toString();
    return {
        attributes: attributes,
        body: body
    };
}
const regex = /\sid="(\S+)"/g;
const randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let counter = 0;
function replaceIDs(body, prefix = randomPrefix) {
    const ids = [];
    let match;
    while(match = regex.exec(body))ids.push(match[1]);
    if (!ids.length) return body;
    const suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
    ids.forEach((id)=>{
        const newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
        const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        body = body.replace(// Allowed characters before id: [#;"]
        // Allowed characters after id: [)"], .[a-z]
        new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + suffix + "$3");
    });
    body = body.replace(new RegExp(suffix, "g"), "");
    return body;
}
const storage = /* @__PURE__ */ Object.create(null);
function setAPIModule(provider, item) {
    storage[provider] = item;
}
function getAPIModule(provider) {
    return storage[provider] || storage[""];
}
function createAPIConfig(source) {
    let resources;
    if (typeof source.resources === "string") resources = [
        source.resources
    ];
    else {
        resources = source.resources;
        if (!(resources instanceof Array) || !resources.length) return null;
    }
    const result = {
        resources: // API hosts
        resources,
        // Root path
        path: source.path || "/",
        // URL length limit
        maxURL: source.maxURL || 500,
        // Timeout before next host is used.
        rotate: source.rotate || 750,
        // Timeout before failing query.
        timeout: source.timeout || 5e3,
        // Randomise default API end point.
        random: source.random === true,
        // Start index
        index: source.index || 0,
        // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
        dataAfterTimeout: source.dataAfterTimeout !== false
    };
    return result;
}
const configStorage = /* @__PURE__ */ Object.create(null);
const fallBackAPISources = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
];
const fallBackAPI = [];
while(fallBackAPISources.length > 0){
    if (fallBackAPISources.length === 1) fallBackAPI.push(fallBackAPISources.shift());
    else if (Math.random() > 0.5) fallBackAPI.push(fallBackAPISources.shift());
    else fallBackAPI.push(fallBackAPISources.pop());
}
configStorage[""] = createAPIConfig({
    resources: [
        "https://api.iconify.design"
    ].concat(fallBackAPI)
});
function addAPIProvider(provider, customConfig) {
    const config = createAPIConfig(customConfig);
    if (config === null) return false;
    configStorage[provider] = config;
    return true;
}
function getAPIConfig(provider) {
    return configStorage[provider];
}
function listAPIProviders() {
    return Object.keys(configStorage);
}
const detectFetch = ()=>{
    let callback;
    try {
        callback = fetch;
        if (typeof callback === "function") return callback;
    } catch (err) {}
};
let fetchModule = detectFetch();
function setFetch(fetch2) {
    fetchModule = fetch2;
}
function getFetch() {
    return fetchModule;
}
function calculateMaxLength(provider, prefix) {
    const config = getAPIConfig(provider);
    if (!config) return 0;
    let result;
    if (!config.maxURL) result = 0;
    else {
        let maxHostLength = 0;
        config.resources.forEach((item)=>{
            const host = item;
            maxHostLength = Math.max(maxHostLength, host.length);
        });
        const url = prefix + ".json?icons=";
        result = config.maxURL - maxHostLength - config.path.length - url.length;
    }
    return result;
}
function shouldAbort(status) {
    return status === 404;
}
const prepare = (provider, prefix, icons)=>{
    const results = [];
    const maxLength = calculateMaxLength(provider, prefix);
    const type = "icons";
    let item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
    };
    let length = 0;
    icons.forEach((name, index)=>{
        length += name.length + 1;
        if (length >= maxLength && index > 0) {
            results.push(item);
            item = {
                type: type,
                provider: provider,
                prefix: prefix,
                icons: []
            };
            length = name.length;
        }
        item.icons.push(name);
    });
    results.push(item);
    return results;
};
function getPath(provider) {
    if (typeof provider === "string") {
        const config = getAPIConfig(provider);
        if (config) return config.path;
    }
    return "/";
}
const send = (host, params, callback)=>{
    if (!fetchModule) {
        callback("abort", 424);
        return;
    }
    let path = getPath(params.provider);
    switch(params.type){
        case "icons":
            {
                const prefix = params.prefix;
                const icons = params.icons;
                const iconsList = icons.join(",");
                const urlParams = new URLSearchParams({
                    icons: iconsList
                });
                path += prefix + ".json?" + urlParams.toString();
                break;
            }
        case "custom":
            {
                const uri = params.uri;
                path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
                break;
            }
        default:
            callback("abort", 400);
            return;
    }
    let defaultError = 503;
    fetchModule(host + path).then((response)=>{
        const status = response.status;
        if (status !== 200) {
            setTimeout(()=>{
                callback(shouldAbort(status) ? "abort" : "next", status);
            });
            return;
        }
        defaultError = 501;
        return response.json();
    }).then((data)=>{
        if (typeof data !== "object" || data === null) {
            setTimeout(()=>{
                if (data === 404) callback("abort", data);
                else callback("next", defaultError);
            });
            return;
        }
        setTimeout(()=>{
            callback("success", data);
        });
    }).catch(()=>{
        callback("next", defaultError);
    });
};
const fetchAPIModule = {
    prepare: prepare,
    send: send
};
function sortIcons(icons) {
    const result = {
        loaded: [],
        missing: [],
        pending: []
    };
    const storage = /* @__PURE__ */ Object.create(null);
    icons.sort((a, b)=>{
        if (a.provider !== b.provider) return a.provider.localeCompare(b.provider);
        if (a.prefix !== b.prefix) return a.prefix.localeCompare(b.prefix);
        return a.name.localeCompare(b.name);
    });
    let lastIcon = {
        provider: "",
        prefix: "",
        name: ""
    };
    icons.forEach((icon)=>{
        if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) return;
        lastIcon = icon;
        const provider = icon.provider;
        const prefix = icon.prefix;
        const name = icon.name;
        const providerStorage = storage[provider] || (storage[provider] = /* @__PURE__ */ Object.create(null));
        const localStorage = providerStorage[prefix] || (providerStorage[prefix] = getStorage(provider, prefix));
        let list;
        if (name in localStorage.icons) list = result.loaded;
        else if (prefix === "" || localStorage.missing.has(name)) list = result.missing;
        else list = result.pending;
        const item = {
            provider: provider,
            prefix: prefix,
            name: name
        };
        list.push(item);
    });
    return result;
}
function removeCallback(storages, id) {
    storages.forEach((storage)=>{
        const items = storage.loaderCallbacks;
        if (items) storage.loaderCallbacks = items.filter((row)=>row.id !== id);
    });
}
function updateCallbacks(storage) {
    if (!storage.pendingCallbacksFlag) {
        storage.pendingCallbacksFlag = true;
        setTimeout(()=>{
            storage.pendingCallbacksFlag = false;
            const items = storage.loaderCallbacks ? storage.loaderCallbacks.slice(0) : [];
            if (!items.length) return;
            let hasPending = false;
            const provider = storage.provider;
            const prefix = storage.prefix;
            items.forEach((item)=>{
                const icons = item.icons;
                const oldLength = icons.pending.length;
                icons.pending = icons.pending.filter((icon)=>{
                    if (icon.prefix !== prefix) return true;
                    const name = icon.name;
                    if (storage.icons[name]) icons.loaded.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else if (storage.missing.has(name)) icons.missing.push({
                        provider: provider,
                        prefix: prefix,
                        name: name
                    });
                    else {
                        hasPending = true;
                        return true;
                    }
                    return false;
                });
                if (icons.pending.length !== oldLength) {
                    if (!hasPending) removeCallback([
                        storage
                    ], item.id);
                    item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
                }
            });
        });
    }
}
let idCounter = 0;
function storeCallback(callback, icons, pendingSources) {
    const id = idCounter++;
    const abort = removeCallback.bind(null, pendingSources, id);
    if (!icons.pending.length) return abort;
    const item = {
        id: id,
        icons: icons,
        callback: callback,
        abort: abort
    };
    pendingSources.forEach((storage)=>{
        (storage.loaderCallbacks || (storage.loaderCallbacks = [])).push(item);
    });
    return abort;
}
function listToIcons(list, validate = true, simpleNames = false) {
    const result = [];
    list.forEach((item)=>{
        const icon = typeof item === "string" ? stringToIcon(item, validate, simpleNames) : item;
        if (icon) result.push(icon);
    });
    return result;
}
// src/config.ts
var defaultConfig = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: false,
    dataAfterTimeout: false
};
// src/query.ts
function sendQuery(config, payload, query, done) {
    const resourcesCount = config.resources.length;
    const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
    let resources;
    if (config.random) {
        let list = config.resources.slice(0);
        resources = [];
        while(list.length > 1){
            const nextIndex = Math.floor(Math.random() * list.length);
            resources.push(list[nextIndex]);
            list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
        }
        resources = resources.concat(list);
    } else resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
    const startTime = Date.now();
    let status = "pending";
    let queriesSent = 0;
    let lastError;
    let timer = null;
    let queue = [];
    let doneCallbacks = [];
    if (typeof done === "function") doneCallbacks.push(done);
    function resetTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function abort() {
        if (status === "pending") status = "aborted";
        resetTimer();
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function subscribe(callback, overwrite) {
        if (overwrite) doneCallbacks = [];
        if (typeof callback === "function") doneCallbacks.push(callback);
    }
    function getQueryStatus() {
        return {
            startTime: startTime,
            payload: payload,
            status: status,
            queriesSent: queriesSent,
            queriesPending: queue.length,
            subscribe: subscribe,
            abort: abort
        };
    }
    function failQuery() {
        status = "failed";
        doneCallbacks.forEach((callback)=>{
            callback(void 0, lastError);
        });
    }
    function clearQueue() {
        queue.forEach((item)=>{
            if (item.status === "pending") item.status = "aborted";
        });
        queue = [];
    }
    function moduleResponse(item, response, data) {
        const isError = response !== "success";
        queue = queue.filter((queued)=>queued !== item);
        switch(status){
            case "pending":
                break;
            case "failed":
                if (isError || !config.dataAfterTimeout) return;
                break;
            default:
                return;
        }
        if (response === "abort") {
            lastError = data;
            failQuery();
            return;
        }
        if (isError) {
            lastError = data;
            if (!queue.length) {
                if (!resources.length) failQuery();
                else execNext();
            }
            return;
        }
        resetTimer();
        clearQueue();
        if (!config.random) {
            const index = config.resources.indexOf(item.resource);
            if (index !== -1 && index !== config.index) config.index = index;
        }
        status = "completed";
        doneCallbacks.forEach((callback)=>{
            callback(data);
        });
    }
    function execNext() {
        if (status !== "pending") return;
        resetTimer();
        const resource = resources.shift();
        if (resource === void 0) {
            if (queue.length) {
                timer = setTimeout(()=>{
                    resetTimer();
                    if (status === "pending") {
                        clearQueue();
                        failQuery();
                    }
                }, config.timeout);
                return;
            }
            failQuery();
            return;
        }
        const item = {
            status: "pending",
            resource: resource,
            callback: (status2, data)=>{
                moduleResponse(item, status2, data);
            }
        };
        queue.push(item);
        queriesSent++;
        timer = setTimeout(execNext, config.rotate);
        query(resource, payload, item.callback);
    }
    setTimeout(execNext);
    return getQueryStatus;
}
// src/index.ts
function initRedundancy(cfg) {
    const config = {
        ...defaultConfig,
        ...cfg
    };
    let queries = [];
    function cleanup() {
        queries = queries.filter((item)=>item().status === "pending");
    }
    function query(payload, queryCallback, doneCallback) {
        const query2 = sendQuery(config, payload, queryCallback, (data, error)=>{
            cleanup();
            if (doneCallback) doneCallback(data, error);
        });
        queries.push(query2);
        return query2;
    }
    function find(callback) {
        return queries.find((value)=>{
            return callback(value);
        }) || null;
    }
    const instance = {
        query: query,
        find: find,
        setIndex: (index)=>{
            config.index = index;
        },
        getIndex: ()=>config.index,
        cleanup: cleanup
    };
    return instance;
}
function emptyCallback$1() {}
const redundancyCache = /* @__PURE__ */ Object.create(null);
function getRedundancyCache(provider) {
    if (!redundancyCache[provider]) {
        const config = getAPIConfig(provider);
        if (!config) return;
        const redundancy = initRedundancy(config);
        const cachedReundancy = {
            config: config,
            redundancy: redundancy
        };
        redundancyCache[provider] = cachedReundancy;
    }
    return redundancyCache[provider];
}
function sendAPIQuery(target, query, callback) {
    let redundancy;
    let send;
    if (typeof target === "string") {
        const api = getAPIModule(target);
        if (!api) {
            callback(void 0, 424);
            return emptyCallback$1;
        }
        send = api.send;
        const cached = getRedundancyCache(target);
        if (cached) redundancy = cached.redundancy;
    } else {
        const config = createAPIConfig(target);
        if (config) {
            redundancy = initRedundancy(config);
            const moduleKey = target.resources ? target.resources[0] : "";
            const api = getAPIModule(moduleKey);
            if (api) send = api.send;
        }
    }
    if (!redundancy || !send) {
        callback(void 0, 424);
        return emptyCallback$1;
    }
    return redundancy.query(query, send, callback)().abort;
}
const browserCacheVersion = "iconify2";
const browserCachePrefix = "iconify";
const browserCacheCountKey = browserCachePrefix + "-count";
const browserCacheVersionKey = browserCachePrefix + "-version";
const browserStorageHour = 36e5;
const browserStorageCacheExpiration = 168;
function getStoredItem(func, key) {
    try {
        return func.getItem(key);
    } catch (err) {}
}
function setStoredItem(func, key, value) {
    try {
        func.setItem(key, value);
        return true;
    } catch (err) {}
}
function removeStoredItem(func, key) {
    try {
        func.removeItem(key);
    } catch (err) {}
}
function setBrowserStorageItemsCount(storage, value) {
    return setStoredItem(storage, browserCacheCountKey, value.toString());
}
function getBrowserStorageItemsCount(storage) {
    return parseInt(getStoredItem(storage, browserCacheCountKey)) || 0;
}
const browserStorageConfig = {
    local: true,
    session: true
};
const browserStorageEmptyItems = {
    local: /* @__PURE__ */ new Set(),
    session: /* @__PURE__ */ new Set()
};
let browserStorageStatus = false;
function setBrowserStorageStatus(status) {
    browserStorageStatus = status;
}
let _window = typeof window === "undefined" ? {} : window;
function getBrowserStorage(key) {
    const attr = key + "Storage";
    try {
        if (_window && _window[attr] && typeof _window[attr].length === "number") return _window[attr];
    } catch (err) {}
    browserStorageConfig[key] = false;
}
function iterateBrowserStorage(key, callback) {
    const func = getBrowserStorage(key);
    if (!func) return;
    const version = getStoredItem(func, browserCacheVersionKey);
    if (version !== browserCacheVersion) {
        if (version) {
            const total2 = getBrowserStorageItemsCount(func);
            for(let i = 0; i < total2; i++)removeStoredItem(func, browserCachePrefix + i.toString());
        }
        setStoredItem(func, browserCacheVersionKey, browserCacheVersion);
        setBrowserStorageItemsCount(func, 0);
        return;
    }
    const minTime = Math.floor(Date.now() / browserStorageHour) - browserStorageCacheExpiration;
    const parseItem = (index)=>{
        const name = browserCachePrefix + index.toString();
        const item = getStoredItem(func, name);
        if (typeof item !== "string") return;
        try {
            const data = JSON.parse(item);
            if (typeof data === "object" && typeof data.cached === "number" && data.cached > minTime && typeof data.provider === "string" && typeof data.data === "object" && typeof data.data.prefix === "string" && // Valid item: run callback
            callback(data, index)) return true;
        } catch (err) {}
        removeStoredItem(func, name);
    };
    let total = getBrowserStorageItemsCount(func);
    for(let i = total - 1; i >= 0; i--)if (!parseItem(i)) {
        if (i === total - 1) {
            total--;
            setBrowserStorageItemsCount(func, total);
        } else browserStorageEmptyItems[key].add(i);
    }
}
function initBrowserStorage() {
    if (browserStorageStatus) return;
    setBrowserStorageStatus(true);
    for(const key in browserStorageConfig)iterateBrowserStorage(key, (item)=>{
        const iconSet = item.data;
        const provider = item.provider;
        const prefix = iconSet.prefix;
        const storage = getStorage(provider, prefix);
        if (!addIconSet(storage, iconSet).length) return false;
        const lastModified = iconSet.lastModified || -1;
        storage.lastModifiedCached = storage.lastModifiedCached ? Math.min(storage.lastModifiedCached, lastModified) : lastModified;
        return true;
    });
}
function updateLastModified(storage, lastModified) {
    const lastValue = storage.lastModifiedCached;
    if (// Matches or newer
    lastValue && lastValue >= lastModified) return lastValue === lastModified;
    storage.lastModifiedCached = lastModified;
    if (lastValue) for(const key in browserStorageConfig)iterateBrowserStorage(key, (item)=>{
        const iconSet = item.data;
        return item.provider !== storage.provider || iconSet.prefix !== storage.prefix || iconSet.lastModified === lastModified;
    });
    return true;
}
function storeInBrowserStorage(storage, data) {
    if (!browserStorageStatus) initBrowserStorage();
    function store(key) {
        let func;
        if (!browserStorageConfig[key] || !(func = getBrowserStorage(key))) return;
        const set = browserStorageEmptyItems[key];
        let index;
        if (set.size) set.delete(index = Array.from(set).shift());
        else {
            index = getBrowserStorageItemsCount(func);
            if (!setBrowserStorageItemsCount(func, index + 1)) return;
        }
        const item = {
            cached: Math.floor(Date.now() / browserStorageHour),
            provider: storage.provider,
            data: data
        };
        return setStoredItem(func, browserCachePrefix + index.toString(), JSON.stringify(item));
    }
    if (data.lastModified && !updateLastModified(storage, data.lastModified)) return;
    if (!Object.keys(data.icons).length) return;
    if (data.not_found) {
        data = Object.assign({}, data);
        delete data.not_found;
    }
    if (!store("local")) store("session");
}
function emptyCallback() {}
function loadedNewIcons(storage) {
    if (!storage.iconsLoaderFlag) {
        storage.iconsLoaderFlag = true;
        setTimeout(()=>{
            storage.iconsLoaderFlag = false;
            updateCallbacks(storage);
        });
    }
}
function loadNewIcons(storage, icons) {
    if (!storage.iconsToLoad) storage.iconsToLoad = icons;
    else storage.iconsToLoad = storage.iconsToLoad.concat(icons).sort();
    if (!storage.iconsQueueFlag) {
        storage.iconsQueueFlag = true;
        setTimeout(()=>{
            storage.iconsQueueFlag = false;
            const { provider, prefix } = storage;
            const icons2 = storage.iconsToLoad;
            delete storage.iconsToLoad;
            let api;
            if (!icons2 || !(api = getAPIModule(provider))) return;
            const params = api.prepare(provider, prefix, icons2);
            params.forEach((item)=>{
                sendAPIQuery(provider, item, (data)=>{
                    if (typeof data !== "object") item.icons.forEach((name)=>{
                        storage.missing.add(name);
                    });
                    else try {
                        const parsed = addIconSet(storage, data);
                        if (!parsed.length) return;
                        const pending = storage.pendingIcons;
                        if (pending) parsed.forEach((name)=>{
                            pending.delete(name);
                        });
                        storeInBrowserStorage(storage, data);
                    } catch (err) {
                        console.error(err);
                    }
                    loadedNewIcons(storage);
                });
            });
        });
    }
}
const loadIcons = (icons, callback)=>{
    const cleanedIcons = listToIcons(icons, true, allowSimpleNames());
    const sortedIcons = sortIcons(cleanedIcons);
    if (!sortedIcons.pending.length) {
        let callCallback = true;
        if (callback) setTimeout(()=>{
            if (callCallback) callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, emptyCallback);
        });
        return ()=>{
            callCallback = false;
        };
    }
    const newIcons = /* @__PURE__ */ Object.create(null);
    const sources = [];
    let lastProvider, lastPrefix;
    sortedIcons.pending.forEach((icon)=>{
        const { provider, prefix } = icon;
        if (prefix === lastPrefix && provider === lastProvider) return;
        lastProvider = provider;
        lastPrefix = prefix;
        sources.push(getStorage(provider, prefix));
        const providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */ Object.create(null));
        if (!providerNewIcons[prefix]) providerNewIcons[prefix] = [];
    });
    sortedIcons.pending.forEach((icon)=>{
        const { provider, prefix, name } = icon;
        const storage = getStorage(provider, prefix);
        const pendingQueue = storage.pendingIcons || (storage.pendingIcons = /* @__PURE__ */ new Set());
        if (!pendingQueue.has(name)) {
            pendingQueue.add(name);
            newIcons[provider][prefix].push(name);
        }
    });
    sources.forEach((storage)=>{
        const { provider, prefix } = storage;
        if (newIcons[provider][prefix].length) loadNewIcons(storage, newIcons[provider][prefix]);
    });
    return callback ? storeCallback(callback, sortedIcons, sources) : emptyCallback;
};
const loadIcon = (icon)=>{
    return new Promise((fulfill, reject)=>{
        const iconObj = typeof icon === "string" ? stringToIcon(icon, true) : icon;
        if (!iconObj) {
            reject(icon);
            return;
        }
        loadIcons([
            iconObj || icon
        ], (loaded)=>{
            if (loaded.length && iconObj) {
                const data = getIconData(iconObj);
                if (data) {
                    fulfill({
                        ...defaultIconProps,
                        ...data
                    });
                    return;
                }
            }
            reject(icon);
        });
    });
};
function toggleBrowserCache(storage, value) {
    switch(storage){
        case "local":
        case "session":
            browserStorageConfig[storage] = value;
            break;
        case "all":
            for(const key in browserStorageConfig)browserStorageConfig[key] = value;
            break;
    }
}
function mergeCustomisations(defaults, item) {
    const result = {
        ...defaults
    };
    for(const key in item){
        const value = item[key];
        const valueType = typeof value;
        if (key in defaultIconSizeCustomisations) {
            if (value === null || value && (valueType === "string" || valueType === "number")) result[key] = value;
        } else if (valueType === typeof result[key]) result[key] = key === "rotate" ? value % 4 : value;
    }
    return result;
}
const separator = /[\s,]+/;
function flipFromString(custom, flip) {
    flip.split(separator).forEach((str)=>{
        const value = str.trim();
        switch(value){
            case "horizontal":
                custom.hFlip = true;
                break;
            case "vertical":
                custom.vFlip = true;
                break;
        }
    });
}
function rotateFromString(value, defaultValue = 0) {
    const units = value.replace(/^-?[0-9.]*/, "");
    function cleanup(value2) {
        while(value2 < 0)value2 += 4;
        return value2 % 4;
    }
    if (units === "") {
        const num = parseInt(value);
        return isNaN(num) ? 0 : cleanup(num);
    } else if (units !== value) {
        let split = 0;
        switch(units){
            case "%":
                split = 25;
                break;
            case "deg":
                split = 90;
        }
        if (split) {
            let num = parseFloat(value.slice(0, value.length - units.length));
            if (isNaN(num)) return 0;
            num = num / split;
            return num % 1 === 0 ? cleanup(num) : 0;
        }
    }
    return defaultValue;
}
function iconToHTML(body, attributes) {
    let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const attr in attributes)renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}
function encodeSVGforURL(svg) {
    return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function svgToData(svg) {
    return "data:image/svg+xml," + encodeSVGforURL(svg);
}
function svgToURL(svg) {
    return 'url("' + svgToData(svg) + '")';
}
const defaultExtendedIconCustomisations = {
    ...defaultIconCustomisations,
    inline: false
};
/**
 * Default SVG attributes
 */ const svgDefaults = {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": true,
    "role": "img"
};
/**
 * Style modes
 */ const commonProps = {
    display: "inline-block"
};
const monotoneProps = {
    backgroundColor: "currentColor"
};
const coloredProps = {
    backgroundColor: "transparent"
};
// Dynamically add common props to variables above
const propsToAdd = {
    Image: "var(--svg)",
    Repeat: "no-repeat",
    Size: "100% 100%"
};
const propsToAddTo = {
    webkitMask: monotoneProps,
    mask: monotoneProps,
    background: coloredProps
};
for(const prefix in propsToAddTo){
    const list = propsToAddTo[prefix];
    for(const prop in propsToAdd)list[prefix + prop] = propsToAdd[prop];
}
/**
 * Aliases for customisations.
 * In Vue 'v-' properties are reserved, so v-flip must be renamed
 */ const customisationAliases = {};
[
    "horizontal",
    "vertical"
].forEach((prefix)=>{
    const attr = prefix.slice(0, 1) + "Flip";
    // vertical-flip
    customisationAliases[prefix + "-flip"] = attr;
    // v-flip
    customisationAliases[prefix.slice(0, 1) + "-flip"] = attr;
    // verticalFlip
    customisationAliases[prefix + "Flip"] = attr;
});
/**
 * Fix size: add 'px' to numbers
 */ function fixSize(value) {
    return value + (value.match(/^[-0-9.]+$/) ? "px" : "");
}
/**
 * Render icon
 */ const render = (// Icon must be validated before calling this function
icon, // Partial properties
props)=>{
    // Split properties
    const customisations = mergeCustomisations(defaultExtendedIconCustomisations, props);
    const componentProps = {
        ...svgDefaults
    };
    // Check mode
    const mode = props.mode || "svg";
    // Copy style
    const style = {};
    const propsStyle = props.style;
    const customStyle = typeof propsStyle === "object" && !(propsStyle instanceof Array) ? propsStyle : {};
    // Get element properties
    for(let key in props){
        const value = props[key];
        if (value === void 0) continue;
        switch(key){
            // Properties to ignore
            case "icon":
            case "style":
            case "onLoad":
            case "mode":
                break;
            // Boolean attributes
            case "inline":
            case "hFlip":
            case "vFlip":
                customisations[key] = value === true || value === "true" || value === 1;
                break;
            // Flip as string: 'horizontal,vertical'
            case "flip":
                if (typeof value === "string") flipFromString(customisations, value);
                break;
            // Color: override style
            case "color":
                style.color = value;
                break;
            // Rotation as string
            case "rotate":
                if (typeof value === "string") customisations[key] = rotateFromString(value);
                else if (typeof value === "number") customisations[key] = value;
                break;
            // Remove aria-hidden
            case "ariaHidden":
            case "aria-hidden":
                // Vue transforms 'aria-hidden' property to 'ariaHidden'
                if (value !== true && value !== "true") delete componentProps["aria-hidden"];
                break;
            default:
                {
                    const alias = customisationAliases[key];
                    if (alias) // Aliases for boolean customisations
                    {
                        if (value === true || value === "true" || value === 1) customisations[alias] = true;
                    } else if (defaultExtendedIconCustomisations[key] === void 0) // Copy missing property if it does not exist in customisations
                    componentProps[key] = value;
                }
        }
    }
    // Generate icon
    const item = iconToSVG(icon, customisations);
    const renderAttribs = item.attributes;
    // Inline display
    if (customisations.inline) style.verticalAlign = "-0.125em";
    if (mode === "svg") {
        // Add style
        componentProps.style = {
            ...style,
            ...customStyle
        };
        // Add icon stuff
        Object.assign(componentProps, renderAttribs);
        // Counter for ids based on "id" property to render icons consistently on server and client
        let localCounter = 0;
        let id = props.id;
        if (typeof id === "string") // Convert '-' to '_' to avoid errors in animations
        id = id.replace(/-/g, "_");
        // Add innerHTML and style to props
        componentProps["innerHTML"] = replaceIDs(item.body, id ? ()=>id + "ID" + localCounter++ : "iconifyVue");
        // Render icon
        return (0, $TusQn.h)("svg", componentProps);
    }
    // Render <span> with style
    const { body, width, height } = icon;
    const useMask = mode === "mask" || (mode === "bg" ? false : body.indexOf("currentColor") !== -1);
    // Generate SVG
    const html = iconToHTML(body, {
        ...renderAttribs,
        width: width + "",
        height: height + ""
    });
    // Generate style
    componentProps.style = {
        ...style,
        "--svg": svgToURL(html),
        "width": fixSize(renderAttribs.width),
        "height": fixSize(renderAttribs.height),
        ...commonProps,
        ...useMask ? monotoneProps : coloredProps,
        ...customStyle
    };
    return (0, $TusQn.h)("span", componentProps);
};
/**
 * Enable cache
 */ function enableCache(storage) {
    toggleBrowserCache(storage, true);
}
/**
 * Disable cache
 */ function disableCache(storage) {
    toggleBrowserCache(storage, false);
}
/**
 * Initialise stuff
 */ // Enable short names
allowSimpleNames(true);
// Set API module
setAPIModule("", fetchAPIModule);
/**
 * Browser stuff
 */ if (typeof document !== "undefined" && typeof window !== "undefined") {
    // Set cache and load existing cache
    initBrowserStorage();
    const _window = window;
    // Load icons from global "IconifyPreload"
    if (_window.IconifyPreload !== void 0) {
        const preload = _window.IconifyPreload;
        const err = "Invalid IconifyPreload syntax.";
        if (typeof preload === "object" && preload !== null) (preload instanceof Array ? preload : [
            preload
        ]).forEach((item)=>{
            try {
                if (// Check if item is an object and not null/array
                typeof item !== "object" || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
                typeof item.icons !== "object" || typeof item.prefix !== "string" || // Add icon set
                !addCollection(item)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        });
    }
    // Set API from global "IconifyProviders"
    if (_window.IconifyProviders !== void 0) {
        const providers = _window.IconifyProviders;
        if (typeof providers === "object" && providers !== null) for(let key in providers){
            const err = "IconifyProviders[" + key + "] is invalid.";
            try {
                const value = providers[key];
                if (typeof value !== "object" || !value || value.resources === void 0) continue;
                if (!addAPIProvider(key, value)) console.error(err);
            } catch (e) {
                console.error(err);
            }
        }
    }
}
/**
 * Empty icon data, rendered when icon is not available
 */ const emptyIcon = {
    ...defaultIconProps,
    body: ""
};
const Icon = (0, $TusQn.defineComponent)({
    // Do not inherit other attributes: it is handled by render()
    inheritAttrs: false,
    // Set initial data
    data () {
        return {
            // Mounted status
            iconMounted: false,
            // Callback counter to trigger re-render
            counter: 0
        };
    },
    mounted () {
        // Current icon name
        this._name = "";
        // Loading
        this._loadingIcon = null;
        // Mark as mounted
        this.iconMounted = true;
    },
    unmounted () {
        this.abortLoading();
    },
    methods: {
        abortLoading () {
            if (this._loadingIcon) {
                this._loadingIcon.abort();
                this._loadingIcon = null;
            }
        },
        // Get data for icon to render or null
        getIcon (icon, onload) {
            // Icon is an object
            if (typeof icon === "object" && icon !== null && typeof icon.body === "string") {
                // Stop loading
                this._name = "";
                this.abortLoading();
                return {
                    data: icon
                };
            }
            // Invalid icon?
            let iconName;
            if (typeof icon !== "string" || (iconName = stringToIcon(icon, false, true)) === null) {
                this.abortLoading();
                return null;
            }
            // Load icon
            const data = getIconData(iconName);
            if (!data) {
                // Icon data is not available
                if (!this._loadingIcon || this._loadingIcon.name !== icon) {
                    // New icon to load
                    this.abortLoading();
                    this._name = "";
                    if (data !== null) // Icon was not loaded
                    this._loadingIcon = {
                        name: icon,
                        abort: loadIcons([
                            iconName
                        ], ()=>{
                            this.counter++;
                        })
                    };
                }
                return null;
            }
            // Icon data is available
            this.abortLoading();
            if (this._name !== icon) {
                this._name = icon;
                if (onload) onload(icon);
            }
            // Add classes
            const classes = [
                "iconify"
            ];
            if (iconName.prefix !== "") classes.push("iconify--" + iconName.prefix);
            if (iconName.provider !== "") classes.push("iconify--" + iconName.provider);
            return {
                data: data,
                classes: classes
            };
        }
    },
    // Render icon
    render () {
        // Re-render when counter changes
        this.counter;
        const props = this.$attrs;
        // Get icon data
        const icon = this.iconMounted ? this.getIcon(props.icon, props.onLoad) : null;
        // Validate icon object
        if (!icon) return render(emptyIcon, props);
        // Add classes
        let newProps = props;
        if (icon.classes) newProps = {
            ...props,
            class: (typeof props["class"] === "string" ? props["class"] + " " : "") + icon.classes.join(" ")
        };
        // Render icon
        return render({
            ...defaultIconProps,
            ...icon.data
        }, newProps);
    }
});
/**
 * Internal API
 */ const _api = {
    getAPIConfig: getAPIConfig,
    setAPIModule: setAPIModule,
    sendAPIQuery: sendAPIQuery,
    setFetch: setFetch,
    getFetch: getFetch,
    listAPIProviders: listAPIProviders
};

});

parcelRegister("gu6an", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc8318eb5dfc4f21$export$2e2bcd8739ae039);
var $fc8318eb5dfc4f21$export$2e2bcd8739ae039;
$fc8318eb5dfc4f21$export$2e2bcd8739ae039 = class InputManager extends EventTarget {
    constructor(){
        super();
        window.addEventListener("keydown", (event)=>{
            if (event.defaultPrevented) return;
            let eventType;
            switch(event.key){
                case "F13":
                case "ArrowRight":
                case "a":
                    eventType = "clockwise";
                    break;
                case "F14":
                case "ArrowLeft":
                case "b":
                    eventType = "counterclockwise";
                    break;
                case "F15":
                case "Enter":
                    eventType = "press";
                    break;
                case "F16":
                case "ArrowUp":
                    eventType = "pressclockwise";
                    break;
                case "F17":
                case "ArrowDown":
                    eventType = "presscounterclockwise";
                    break;
                case "F18":
                case "Space":
                    eventType = "longpress";
                    break;
                default:
                    return;
            }
            console.log(eventType);
            let customEvent = new CustomEvent(eventType);
            this.dispatchEvent(customEvent);
        });
    }
};

});

parcelRegister("7kSGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $72de85861c825b39$export$2e2bcd8739ae039);

const $72de85861c825b39$var$BackgroundUrl = new URL((parcelRequire("6v5cJ"))).toString();

const $72de85861c825b39$var$ClickUrl = new URL((parcelRequire("jgONn"))).toString();
const $72de85861c825b39$var$IntensityDefault = 1;
const $72de85861c825b39$var$IntensityStep = 1 / 36;
const $72de85861c825b39$var$VolumeStep = .05;
const $72de85861c825b39$var$AudioData = {
    channels: [
        {
            name: "Ambience",
            resetTime: true,
            tracks: [
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                }
            ]
        },
        {
            name: "Classical Low Valence",
            tracks: [
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Classical_LowValence_MidIntensity_Processed.mp3",
                    duration: 7202.951837
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Classical_LowValence_HighIntensity.mp3",
                    duration: 7200.026122
                }
            ]
        },
        {
            name: "Classical High Valence",
            tracks: [
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Classical_HighValance_MidIntensity.mp3",
                    duration: 7200.024000
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Classical_HighValence_HighIntensity.mp3",
                    duration: 7200.055400
                }
            ]
        },
        {
            name: "Synth High Valence",
            tracks: [
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Synth_HighValence_MidIntensity.mp3",
                    duration: 7200.096000
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Synth_HighValence_HighIntensity.mp3",
                    duration: 7200.055400
                }
            ]
        },
        {
            name: "Synth Mid Valence",
            tracks: [
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Synth_MediumValence_MidIntensity.mp3",
                    duration: 7200.096000
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Synth_MediumValence_HighIntensity.mp3",
                    duration: 7200.055400
                }
            ]
        },
        {
            name: "Synth Low Valence",
            tracks: [
                {
                    src: "https://gilgamesh.r2.objectnormal.com/OceanAmbience.mp3",
                    duration: 50.703673
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Synth_LowValence_MidIntensity.mp3",
                    duration: 7200.024000
                },
                {
                    src: "https://gilgamesh.r2.objectnormal.com/Synth_LowValence_HighIntensity.mp3",
                    duration: 7200.026122
                }
            ]
        }
    ]
};
const $72de85861c825b39$var$Keyframes = [
    [
        {
            time: 0,
            value: 1
        },
        {
            time: .5,
            value: 0
        }
    ],
    [
        {
            time: 0,
            value: 0
        },
        {
            time: .5,
            value: 1
        },
        {
            time: 1,
            value: 0
        }
    ],
    [
        {
            time: .5,
            value: 0
        },
        {
            time: 1,
            value: 1
        }
    ]
];
class $72de85861c825b39$var$AudioSource {
    constructor(audioContext, outputNode){
        this.audioContext = audioContext;
        this.fadeNode = this.audioContext.createGain();
        this.fadeNode.connect(outputNode);
        this.fadeNode.gain.value = 1;
        this.intensityNode = this.audioContext.createGain();
        this.intensityNode.connect(this.fadeNode);
        this.audioElement = new Audio();
        this.audioElement.controls = false;
        this.audioElement.loop = true;
        this.audioElement.crossOrigin = "anonymous";
        this.sourceNode = this.audioContext.createMediaElementSource(this.audioElement);
        this.sourceNode.connect(this.intensityNode);
    }
    play() {
        console.log("Playing...");
        let duration = 2;
        this.audioElement.play();
        this.fadeNode.gain.value = 0;
        this.fadeNode.gain.linearRampToValueAtTime(1, this.audioContext.currentTime + duration);
    }
    stop() {
        console.log("Stopping...");
        let duration = 2;
        this.fadeNode.gain.linearRampToValueAtTime(0, this.audioContext.currentTime + duration);
        setTimeout(()=>{
            this.dispose();
        }, duration * 1000);
    }
    dispose() {
        // Clear the source and pause the audio element
        this.audioElement.src = "";
        this.audioElement.load();
        this.audioElement.pause();
        // Disconnect the nodes
        this.sourceNode.disconnect();
        this.intensityNode.disconnect();
    }
    setVolume(volume) {
        // Set the volume using the gain node
        this.intensityNode.gain.setValueAtTime(volume, this.audioContext.currentTime);
    }
    setSource(source) {
        this.audioElement.pause;
        this.audioElement.src = source;
        this.audioElement.load();
    }
    setDuration(duration) {
        this.duration = duration;
    }
    pauseAudio() {
        this.audioElement.pause();
    }
    resumeAudio() {
        this.audioElement.play();
    }
}
var $72de85861c825b39$export$2e2bcd8739ae039;
$72de85861c825b39$export$2e2bcd8739ae039 = class AudioManager extends EventTarget {
    constructor(){
        super();
        this.channelIndex = 0;
        this.intensity = $72de85861c825b39$var$IntensityDefault;
        this.masterVolume = 1;
        this.audioSources = [];
        this.audioCanPlayCount = 0;
        this.audioSeekedCount = 0;
        this.audioContext = new AudioContext();
        this.audioClockOffset = 0;
        this.audioClockPauseTime = 0;
        this.audioClockPaused = false;
        this.masterGainNode = this.audioContext.createGain();
        this.onseeked = (event)=>{
            this.audioSeekedCount++;
            console.log(`Seek complete! ${event.target}`);
            if (this.audioSeekedCount == 3) {
                if (!this.audioClockPaused) this.playAtCurrentTime();
                this.audioSeekedCount = 0;
            }
        };
        // Audio context setup.
        this.masterGainNode.connect(this.audioContext.destination);
        // Clicks at knob boundaries.
        this.clickSource = new $72de85861c825b39$var$AudioSource(this.audioContext, this.audioContext.destination);
        this.clickSource.setSource($72de85861c825b39$var$ClickUrl);
        this.clickSource.audioElement.loop = false;
        // Background audio to set volume.
        this.backgroundSource = new $72de85861c825b39$var$AudioSource(this.audioContext, this.masterGainNode);
        this.backgroundSource.setSource($72de85861c825b39$var$BackgroundUrl);
    }
    playAtCurrentTime() {
        console.log("Playing at current time!");
        for(let i = 0; i < 3; i++){
            this.audioSources[i].play();
            this.audioCanPlayCount = 0;
            this.audioSeekedCount = 0;
        }
    }
    initialize() {
        if (this.audioContext.state === "suspended") this.audioContext.resume();
    }
    start() {
        this.channelSetAndSeek(0, .01);
    }
    playClick() {
        this.clickSource.audioElement.currentTime = 0;
        this.clickSource.audioElement.play();
    }
    volumeUp() {
        if (this.masterVolume >= 1) this.playClick();
        let value = Math.min(1, this.masterVolume + $72de85861c825b39$var$VolumeStep);
        return this.volumeSet(value);
    }
    volumeDown() {
        if (this.masterVolume <= 0) this.playClick();
        let value = Math.max(0, this.masterVolume - $72de85861c825b39$var$VolumeStep);
        return this.volumeSet(value);
    }
    volumeSet(value) {
        console.log("Volume: " + value);
        this.masterVolume = value;
        this.masterGainNode.gain.setValueAtTime(this.masterVolume, this.audioContext.currentTime);
        return this.masterVolume;
    }
    playBackground() {
        console.log("Playing background...");
        this.backgroundSource.play();
    }
    stopBackground() {
        console.log("Stopping background...");
        this.backgroundSource.stop();
    }
    get time() {
        return this.audioClockPaused ? this.audioClockPauseTime - this.audioClockOffset : this.audioContext.currentTime - this.audioClockOffset;
    }
    get audioData() {
        return $72de85861c825b39$var$AudioData;
    }
    refreshClock(value) {
        if (this.audioClockPaused) this.audioClockOffset = this.audioClockPauseTime - value;
        else this.audioClockOffset = this.audioContext.currentTime - value;
    }
    pauseClock() {
        if (this.audioClockPaused == false) {
            this.audioClockPaused = true;
            this.audioClockPauseTime = this.audioContext.currentTime;
        }
    }
    resumeClock() {
        if (this.audioClockPaused == true) {
            this.audioClockPaused = false;
            this.audioClockOffset += this.audioContext.currentTime - this.audioClockPauseTime;
        }
    }
    pauseAllTracks() {
        this.pauseClock();
        for(let i = 0; i < 3; i++)this.audioSources[i].pauseAudio();
    }
    resumeAllTracks() {
        this.resumeClock();
        for(let i = 0; i < 3; i++)this.audioSources[i].resumeAudio();
    }
    seek(time) {
        this.channelSetAndSeek(this.channelIndex, time, true);
    }
    channelNext() {
        let nextIndex = (this.channelIndex + 1) % $72de85861c825b39$var$AudioData.channels.length;
        return this.channelSetAndSeek(nextIndex, this.time);
    }
    channelPrevious() {
        let previousIndex = this.channelIndex == 0 ? $72de85861c825b39$var$AudioData.channels.length - 1 : this.channelIndex - 1;
        return this.channelSetAndSeek(previousIndex, this.time);
    }
    channelSet(index) {
        let time = this.time;
        if (index != this.channelIndex && $72de85861c825b39$var$AudioData.channels[this.channelIndex].resetTime) time = .01;
        return this.channelSetAndSeek(index, time);
    }
    channelSetAndSeek(index, time, keepIntensity = false) {
        console.log(`Channel set and seek. Index: ${index}, Time: ${time}`);
        // Set clock.
        this.refreshClock(time);
        // Set new channel.
        this.channelIndex = index;
        let channel = $72de85861c825b39$var$AudioData.channels[index];
        // Manage audio sources.
        for(let i = 0; i < 3; i++){
            // Fade existing
            console.log("Fading existing audio source: " + i);
            if (this.audioSources.length > i && this.audioSources[i] != null) this.audioSources[i].stop();
            console.log("Creating new audio sources: " + i);
            this.audioSources[i] = new $72de85861c825b39$var$AudioSource(this.audioContext, this.masterGainNode);
            // Play whenever there's a sync'd seek.
            this.audioSources[i].audioElement.onseeked = this.onseeked;
            this.audioSources[i].setSource(channel.tracks[i].src);
            this.audioSources[i].setDuration(channel.tracks[i].duration);
            // Pause.
            this.audioSources[i].audioElement.pause();
            // Set time.
            if (time >= 0) {
                let duration = this.audioSources[i].duration;
                let seekTime = time % duration;
                this.audioSources[i].audioElement.currentTime = seekTime;
            }
        }
        this.audioCanPlayCount = 0;
        this.audioSeekedCount = 0;
        if (keepIntensity) this.intensitySet(this.intensity);
        else this.intensitySet($72de85861c825b39$var$IntensityDefault);
        return this.channelIndex;
    }
    // Update the track progress and update volumes.
    intensityUp() {
        if (this.intensity >= 1) this.playClick();
        let value = Math.min(1, this.intensity + $72de85861c825b39$var$IntensityStep);
        this.intensitySet(value);
    }
    // Update the track progress and update volumes.
    intensityDown() {
        if (this.intensity <= 0) this.playClick();
        let value = Math.max(0, this.intensity - $72de85861c825b39$var$IntensityStep);
        this.intensitySet(value);
    }
    intensitySet(value) {
        this.intensity = value;
        const volumes = [];
        for(let i = 0; i < 3; i++){
            let keyframes = $72de85861c825b39$var$Keyframes[i];
            let audioSource = this.audioSources[i];
            if (keyframes.length > 0) {
                if (this.intensity <= keyframes[0].time) {
                    // Hold before first keyframe.
                    const value = keyframes[0].value;
                    volumes.push(value);
                    audioSource.setVolume(value);
                } else if (this.intensity >= keyframes[keyframes.length - 1].time) {
                    // Hold faster last keyframe.
                    const value = keyframes[keyframes.length - 1].value;
                    volumes.push(value);
                    audioSource.setVolume(value);
                } else for(let i = 0; i < keyframes.length - 1; i++){
                    let currentKeyframe = keyframes[i];
                    let nextKeyframe = keyframes[i + 1];
                    if (currentKeyframe.time <= this.intensity && nextKeyframe.time >= this.intensity) {
                        let alpha = (this.intensity - currentKeyframe.time) / (nextKeyframe.time - currentKeyframe.time);
                        let value = (1 - alpha) * currentKeyframe.value + alpha * nextKeyframe.value;
                        volumes.push(value);
                        audioSource.setVolume(value);
                        break;
                    }
                }
            }
        }
        this.dispatchEvent(new CustomEvent("intensityChange", {
            detail: {
                intensity: this.intensity,
                volumes: volumes
            }
        }));
        return this.intensity;
    }
};

});
parcelRegister("6v5cJ", function(module, exports) {
module.exports = new URL("background.91b2fd83.mp3", import.meta.url).toString();

});

parcelRegister("jgONn", function(module, exports) {
module.exports = new URL("click.63fde77d.mp3", import.meta.url).toString();

});


parcelRegister("eEby5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b12d42a4b328382$export$2e2bcd8739ae039);
var $9b12d42a4b328382$export$2e2bcd8739ae039;
$9b12d42a4b328382$export$2e2bcd8739ae039 = class AudioRecorder {
    constructor(){
        this.mediaStream = null;
        this.audioChunks = [];
        this.mediaRecorder = null;
        this.audioContext = new AudioContext();
    // this.requestMicrophonePermission();
    }
    async requestMicrophonePermission() {
        try {
            this.mediaStream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
        } catch (error) {
            console.log("Error accessing the microphone:", error);
        }
    }
    async startRecording() {
        if (!this.mediaStream) {
            console.error("Microphone permission not granted.");
            return;
        }
        this.audioChunks = [];
        this.mediaRecorder = new MediaRecorder(this.mediaStream, {
            mimeType: "audio/webm",
            audioBitsPerSecond: 128000
        });
        this.mediaRecorder.ondataavailable = (event)=>{
            if (event.data.size > 0) this.audioChunks.push(event.data);
        };
        this.mediaRecorder.onstop = ()=>{};
        this.mediaRecorder.start();
    }
    stopRecording() {
        if (this.mediaRecorder) this.mediaRecorder.stop();
    }
    saveRecording(filename) {
        if (this.audioChunks.length === 0) return;
        const audioBlob = new Blob(this.audioChunks, {
            type: "audio/webm"
        });
        const audioUrl = URL.createObjectURL(audioBlob);
        const downloadLink = document.createElement("a");
        downloadLink.href = audioUrl;
        downloadLink.download = filename + ".webm";
        downloadLink.click();
        this.audioChunks = [];
    }
};

});


parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $2c4cb1eb429dee56$var$_hoisted_1 = {
    class: "grid place-items-center h-full"
};
const $2c4cb1eb429dee56$var$_hoisted_2 = {
    key: 0
};
const $2c4cb1eb429dee56$var$_hoisted_3 = {
    key: 1,
    class: "grid grid-cols-1 place-items-center"
};
const $2c4cb1eb429dee56$var$_hoisted_4 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("div", {
    class: "pointer-events-none text-zinc-100 text-center my-4"
}, " Press and turn knob to set a comfortable volume. ", -1);
const $2c4cb1eb429dee56$var$_hoisted_5 = {
    key: 2,
    class: "container bg-zinc-100 p-4 sm:rounded-lg sm:m-4 max-w-xl"
};
const $2c4cb1eb429dee56$var$_hoisted_6 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("h1", {
    class: "text-xl"
}, "Control Panel", -1);
const $2c4cb1eb429dee56$var$_hoisted_7 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr", {
    class: "h-px my-4 bg-zinc-200 border-0"
}, null, -1);
const $2c4cb1eb429dee56$var$_hoisted_8 = {
    class: "text-zinc-800 font-semibold mb-2"
};
const $2c4cb1eb429dee56$var$_hoisted_9 = {
    class: "grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4"
};
const $2c4cb1eb429dee56$var$_hoisted_10 = {
    class: "track text-sm col-span-3"
};
const $2c4cb1eb429dee56$var$_hoisted_11 = {
    class: "z-10 relative"
};
const $2c4cb1eb429dee56$var$_hoisted_12 = {
    class: "grid grid-cols-3 gap-4 mb-4"
};
const $2c4cb1eb429dee56$var$_hoisted_13 = {
    class: "grid grid-cols-3 gap-4 mb-4"
};
const $2c4cb1eb429dee56$var$_hoisted_14 = {
    class: "grid grid-cols-2 gap-4 mb-4"
};
const $2c4cb1eb429dee56$var$_hoisted_15 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr", {
    class: "h-px my-4 bg-zinc-200 border-0"
}, null, -1);
const $2c4cb1eb429dee56$var$_hoisted_16 = {
    class: "text-zinc-800 font-semibold mb-2"
};
const $2c4cb1eb429dee56$var$_hoisted_17 = {
    class: "track mb-2"
};
const $2c4cb1eb429dee56$var$_hoisted_18 = {
    class: "grid grid-cols-2 gap-4"
};
const $2c4cb1eb429dee56$var$_hoisted_19 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr", {
    class: "h-px my-4 bg-zinc-200 border-0"
}, null, -1);
const $2c4cb1eb429dee56$var$_hoisted_20 = {
    class: "text-zinc-800 font-semibold mb-2"
};
const $2c4cb1eb429dee56$var$_hoisted_21 = {
    class: "grid grid-cols-7 gap-4"
};
const $2c4cb1eb429dee56$var$_hoisted_22 = [
    "value"
];
const $2c4cb1eb429dee56$var$_hoisted_23 = /*#__PURE__*/ (0, $TusQn.createElementVNode)("hr", {
    class: "h-px my-4 bg-zinc-200 border-0"
}, null, -1);
const $2c4cb1eb429dee56$var$_hoisted_24 = {
    class: "text-zinc-800 font-semibold mb-2"
};
const $2c4cb1eb429dee56$var$_hoisted_25 = {
    class: "track mb-2"
};
const $2c4cb1eb429dee56$var$_hoisted_26 = {
    class: "grid grid-cols-3 gap-4 text-sm mb-4"
};
const $2c4cb1eb429dee56$var$_hoisted_27 = {
    class: "track"
};
const $2c4cb1eb429dee56$var$_hoisted_28 = {
    class: "z-10 relative text-sm"
};
const $2c4cb1eb429dee56$var$_hoisted_29 = {
    class: "track"
};
const $2c4cb1eb429dee56$var$_hoisted_30 = {
    class: "z-10 relative text-sm"
};
const $2c4cb1eb429dee56$var$_hoisted_31 = {
    class: "track"
};
const $2c4cb1eb429dee56$var$_hoisted_32 = {
    class: "z-10 relative text-sm"
};
const $2c4cb1eb429dee56$var$_hoisted_33 = {
    class: "grid grid-cols-2 gap-4 mb-4"
};
const $2c4cb1eb429dee56$var$_hoisted_34 = {
    class: "grid grid-cols-3 gap-4 mb-4"
};
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_1, [
        $setup.appState == $setup.AppState.Splash ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("button", {
                onClick: $setup.start,
                class: "bg-zinc-300 active:bg-cyan-400 w-32 h-32 rounded-full"
            }, " Start ")
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $setup.appState == $setup.AppState.Intro ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_3, [
            (0, $TusQn.createElementVNode)("button", {
                onClick: $setup.next,
                class: "bg-zinc-300 active:bg-cyan-400 w-32 h-32 rounded-full"
            }, "Continue"),
            $2c4cb1eb429dee56$var$_hoisted_4
        ])) : (0, $TusQn.createCommentVNode)("", true),
        $setup.appState == $setup.AppState.Experience ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_5, [
            $2c4cb1eb429dee56$var$_hoisted_6,
            $2c4cb1eb429dee56$var$_hoisted_7,
            (0, $TusQn.createElementVNode)("h2", $2c4cb1eb429dee56$var$_hoisted_8, [
                (0, $TusQn.createVNode)($setup["Icon"], {
                    icon: "mdi:clock-outline",
                    inline: true
                }),
                (0, $TusQn.createTextVNode)(" Time ")
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_9, [
                (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_10, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "absolute top-0 left-0 bg-cyan-400",
                        style: (0, $8POXm.normalizeStyle)({
                            width: `${$setup.floatToPercent($setup.seconds / 7200)}`,
                            height: "100%"
                        })
                    }, null, 4),
                    (0, $TusQn.createElementVNode)("span", $2c4cb1eb429dee56$var$_hoisted_11, " Seconds: " + (0, $8POXm.toDisplayString)($setup.seconds.toFixed(2)), 1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_12, [
                (0, $TusQn.createElementVNode)("button", {
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.seek(.01)),
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-right-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" 0 Min ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.seek(1200)),
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-right-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" 20 Min ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: _cache[2] || (_cache[2] = ($event)=>$setup.seek(3600)),
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-right-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" 60 Min ")
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_13, [
                (0, $TusQn.createElementVNode)("button", {
                    onClick: _cache[3] || (_cache[3] = ($event)=>$setup.seek(2400)),
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-right-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" 40 Min ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: _cache[4] || (_cache[4] = ($event)=>$setup.seek(4800)),
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-right-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" 80 Min ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: _cache[5] || (_cache[5] = ($event)=>$setup.seek(6000)),
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-right-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" 100 Min ")
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_14, [
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.pauseAllTracks,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "mdi:pause"
                    }),
                    (0, $TusQn.createTextVNode)(" Pause ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.resumeAllTracks,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "mdi:play"
                    }),
                    (0, $TusQn.createTextVNode)(" Resume ")
                ])
            ]),
            $2c4cb1eb429dee56$var$_hoisted_15,
            (0, $TusQn.createElementVNode)("h2", $2c4cb1eb429dee56$var$_hoisted_16, [
                (0, $TusQn.createVNode)($setup["Icon"], {
                    inline: true,
                    icon: "mdi-volume"
                }),
                (0, $TusQn.createTextVNode)(" Master Volume (" + (0, $8POXm.toDisplayString)($setup.floatToPercent($setup.masterVolume)) + ") ", 1)
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_17, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "w-full",
                    type: "range",
                    min: "0",
                    max: "1",
                    step: ".01",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.masterVolume = $event),
                    onInput: _cache[7] || (_cache[7] = ($event)=>$setup.volumeSet($setup.masterVolume))
                }, null, 544), [
                    [
                        (0, $eeJ70.vModelText),
                        $setup.masterVolume
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_18, [
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.volumeDown,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:chevron-down-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" Volume Down ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.volumeUp,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:chevron-up-circle"
                    }),
                    (0, $TusQn.createTextVNode)(" Volume Up ")
                ])
            ]),
            $2c4cb1eb429dee56$var$_hoisted_19,
            (0, $TusQn.createElementVNode)("h2", $2c4cb1eb429dee56$var$_hoisted_20, [
                (0, $TusQn.createVNode)($setup["Icon"], {
                    inline: true,
                    icon: "mdi:radio"
                }),
                (0, $TusQn.createTextVNode)(" Channel ")
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_21, [
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.channelPrevious,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-left"
                    })
                ]),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.channel = $event),
                    onChange: _cache[9] || (_cache[9] = ($event)=>$setup.channelSet($setup.channel)),
                    class: "bg-zinc-200 border-zinc-400 border p-2 text-center rounded col-span-5"
                }, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.audioManager.audioData.channels, (channel, index)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                            value: index,
                            key: index
                        }, (0, $8POXm.toDisplayString)(channel.name), 9, $2c4cb1eb429dee56$var$_hoisted_22);
                    }), 128))
                ], 544), [
                    [
                        (0, $eeJ70.vModelSelect),
                        $setup.channel
                    ]
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.channelNext,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-right"
                    })
                ])
            ]),
            $2c4cb1eb429dee56$var$_hoisted_23,
            (0, $TusQn.createElementVNode)("h2", $2c4cb1eb429dee56$var$_hoisted_24, [
                (0, $TusQn.createVNode)($setup["Icon"], {
                    inline: true,
                    icon: "line-md:lightbulb"
                }),
                (0, $TusQn.createTextVNode)(" Master Intensity ")
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_25, [
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                    class: "w-full",
                    type: "range",
                    min: "0",
                    max: "1",
                    step: ".01",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.masterIntensity = $event),
                    onInput: _cache[11] || (_cache[11] = ($event)=>$setup.intensitySet($setup.masterIntensity))
                }, null, 544), [
                    [
                        (0, $eeJ70.vModelText),
                        $setup.masterIntensity
                    ]
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_26, [
                (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_27, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "absolute top-0 left-0 bg-cyan-400",
                        style: (0, $8POXm.normalizeStyle)({
                            width: `${$setup.floatToPercent($setup.trackVolumes[0])}`,
                            height: "100%"
                        })
                    }, null, 4),
                    (0, $TusQn.createElementVNode)("span", $2c4cb1eb429dee56$var$_hoisted_28, " Low: " + (0, $8POXm.toDisplayString)($setup.floatToPercent($setup.trackVolumes[0])), 1)
                ]),
                (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_29, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "absolute top-0 left-0 bg-cyan-400",
                        style: (0, $8POXm.normalizeStyle)({
                            width: `${$setup.floatToPercent($setup.trackVolumes[1])}`,
                            height: "100%"
                        })
                    }, null, 4),
                    (0, $TusQn.createElementVNode)("span", $2c4cb1eb429dee56$var$_hoisted_30, " Medium: " + (0, $8POXm.toDisplayString)($setup.floatToPercent($setup.trackVolumes[1])), 1)
                ]),
                (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_31, [
                    (0, $TusQn.createElementVNode)("div", {
                        class: "absolute top-0 left-0 bg-cyan-400",
                        style: (0, $8POXm.normalizeStyle)({
                            width: `${$setup.floatToPercent($setup.trackVolumes[2])}`,
                            height: "100%"
                        })
                    }, null, 4),
                    (0, $TusQn.createElementVNode)("span", $2c4cb1eb429dee56$var$_hoisted_32, " High: " + (0, $8POXm.toDisplayString)($setup.floatToPercent($setup.trackVolumes[2])), 1)
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_33, [
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.intensityDown,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-down"
                    }),
                    (0, $TusQn.createTextVNode)(" Down ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.intensityUp,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-up"
                    }),
                    (0, $TusQn.createTextVNode)(" Up ")
                ])
            ]),
            (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_34, [
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.intensityMin,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-close-down"
                    }),
                    (0, $TusQn.createTextVNode)(" Min ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.intensityHalf,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-align-middle"
                    }),
                    (0, $TusQn.createTextVNode)(" Half ")
                ]),
                (0, $TusQn.createElementVNode)("button", {
                    onClick: $setup.intensityMax,
                    class: ""
                }, [
                    (0, $TusQn.createVNode)($setup["Icon"], {
                        inline: true,
                        icon: "line-md:arrow-close-up"
                    }),
                    (0, $TusQn.createTextVNode)(" Max ")
                ])
            ])
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");
let $ae3de8900c09c2f9$var$script;



let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = "data-v-73af4c";
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;



const $b4e14b6b8da86996$var$app = (0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
$b4e14b6b8da86996$var$app.mount("#app");


//# sourceMappingURL=index.8a04e96d.js.map
